import moment from 'moment';
import { removeCpfFormatting } from 'utils/formatters';
import { PeriodFilterValuesEnum } from 'utils/periodEnum';
import { FiltersType } from 'v3/data/store/onlineContracting/types';
import { CustomFilterType } from 'v3/shared/components/Filters/OnlineFilter/types';

export const filterRequestFactory = (filterValues: CustomFilterType, filtersState: FiltersType) => {
  const formattedCpf = removeCpfFormatting(filterValues.cpf);
  if (filterValues.period) {
    const newDateRange = getDateRange(filterValues.period);
    filterValues.finalDate = newDateRange.finalDate;
    filterValues.startDate = newDateRange.startDate;
  }

  const filters = {
    ...filtersState,
    status: filterValues.status,
    cpf: formattedCpf,
    finalDate: filterValues.finalDate,
    startDate: filterValues.startDate,
    cancellationStatus: filterValues.cancellationStatus,
  };

  const removeEmptyProperties = Object.fromEntries(Object.entries(filters).filter(([key, value]) => value));
  const { period, ...inputBody } = removeEmptyProperties;

  return inputBody;
};

export const getDateRange = (option: keyof typeof PeriodFilterValuesEnum) => {
  let startDate: string;
  const finalDate: string = moment().endOf('day').toISOString();
  startDate = moment().startOf(option).toISOString();

  return { startDate, finalDate };
};
